export function ZonesToolTip({ mousePos, hoverData }) {
  return (
    <div
      style={{
        position: "fixed",
        top: mousePos.y + 15,
        left: mousePos.x - 55,
        width: "320px",
        backgroundColor: "white",
        borderRadius: "12px",
        boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
        border: "1px solid #eef2f6",
        padding: "16px",
        zIndex: 9999,
        pointerEvents: "none",
        display: "flex",
        flexDirection: "column",
        gap: "12px",
      }}
    >
      <div
        style={{
          fontSize: "10px",
          fontWeight: "bold",
          color: "#64748b",
          textTransform: "uppercase",
          borderBottom: "1px solid #f1f5f9",
          paddingBottom: "6px",
        }}
      >
        {hoverData.title}
      </div>

      <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
        {hoverData.zones.map((z, i) => (
          <div
            key={i}
            style={{
              backgroundColor: hoverData.color,
              color: "white",
              padding: "4px 10px",
              borderRadius: "6px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              minWidth: "80px",
            }}
          >
            <span style={{ fontSize: "10px", fontWeight: "600" }}>
              {z.name}
            </span>
            <span
              style={{
                fontSize: "7px",
                opacity: "0.9",
                textTransform: "uppercase",
              }}
            >
              {z.zone || "Others"}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
